import type { AppRouteRecordRaw } from '@/router/types'

export const cpsRoutes: AppRouteRecordRaw[] = [
  {
    path: 'cpsSignManage',
    name: 'CpsSignManage',
    component: () => import('@/views/cps/signManage/index.vue'),
    meta: { title: 'CPS签单管理', keepAlive: true }
  },
  // {
  //   path: 'cpsSignManageDetail',
  //   name: 'CpsSignManageDetail',
  //   component: () => import('@/views/cps/signManage/signManageDetail/index.vue'),
  //   meta: { title: '签单管理详情页' }
  // },
  {
    path: 'cpsLoanManage',
    name: 'CpsLoanManage',
    component: () => import('@/views/cps/loanManage/index.vue'),
    meta: { title: '放款管理' }
  },
  {
    path: 'visitBackManage',
    name: 'VisitBackManage',
    component: () => import('@/views/cps/returnVisitManage/index.vue'),
    meta: { title: '回访管理', keepAlive: true }
  },

  {
    path: 'violationRecord',
    name: 'ViolationRecord',
    component: () => import('@/views/cps/violationRecord/index.vue'),
    meta: { title: '违规记录', keepAlive: true }
  }
]
